<template>
    <div class="component">
        <div class="vx-row">
            <div class="vx-col w-full font-bold flex">
                <vs-button icon-pack="feather" icon="icon-chevron-left"
                           class="lg:ml-auto ml-0 round size-button mr-2"
                           @click="previousDate"></vs-button>
                <span class="font-bold mt-1 mr-2">{{$t('inputTime.week') }} {{ this.weekOfYear }}: </span>
                <span class="mt-1 text-primary">{{
                        this.date.startDateFormat
                    }} - {{ this.date.endDateFormat }}</span>
                <vs-button icon-pack="feather" icon="icon-chevron-right" class="round size-button ml-2"
                           @click="nextDate"></vs-button>
            </div>
        </div>
        <div class="vx-row mt-4">
            <div class="vx-col w-full">
                <div class="vx-card p-6">
                    <div class="vx-row">
                        <div class="vx-col w-full flex flex-wrap items-center">
                            <div class="lg:w-1/4 sm:w-1/2 w-full">
                                <label class="vs-input--label">{{ $t('navMenu.school') }}</label>
                                <v-select class="w-full" v-model="selectedBranch" :clearable="false"
                                          :options="branchOptions" label="label">
                                    <template #option="{ label, employee }">
                                        <h6 style="margin: 0">{{ label }}</h6>
                                        <em>{{ employee }}</em>
                                    </template>
                                    <template #selected-option="{ label, employee }">
                                        <div class="flex items-center gap-2">
                                            <strong>{{ label }}</strong>
                                            <em>{{ employee }}</em>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                            <div class="lg:w-1/4 sm:w-1/2 w-full ml-2">
                                <label class="vs-input--label">{{$t('timeKeeping.teacherMain') }}:</label>
                                <v-select class="w-full" v-model="selectedEmployee" :clearable="false"
                                          :options="employeeSelectOptions" :reduce="option => option.value"
                                          @input="getSchedule">
                                </v-select>
                            </div>
                            <!--                            <vs-button icon-pack="feather" icon="icon-search" class="mt-6 ml-2" type="border">Tìm kiếm-->
                            <!--                            </vs-button>-->

                            <vx-tooltip class="position-icon mt-6 md:ml-auto mr-2" text="Thêm giáo viên" position="top">
                                <vs-button icon-pack="feather" icon="icon-user-plus"
                                           @click="popupAddTeacher = true"></vs-button>
                            </vx-tooltip>
                            <vx-tooltip class="position-icon mt-6 mr-2" text="Xuất TKB theo GV" position="top">
                                <vs-button icon-pack="feather" icon="icon-download-cloud"
                                           @click="exportTeachingSchedule"></vs-button>
                            </vx-tooltip>
                            <vx-tooltip class="position-icon mt-6 mr-2" text="Xuất TKB theo trường" position="top">
                                <vs-button icon-pack="feather" icon="icon-download"
                                           @click="exportTeachingSchoolSchedule"></vs-button>
                            </vx-tooltip>
                            <vx-tooltip class="position-icon mt-6" text="Cập nhật dữ liệu" position="top">
                                <vs-button icon-pack="feather" icon="icon-refresh-cw" @click="updateData"></vs-button>
                            </vx-tooltip>

                        </div>
                    </div>
                    <div class="height-table mt-6">
                        <vs-table :data="employeeList" noDataText="Không có dữ liệu">
                            <template slot="thead">
                                <vs-th class="border text-center bg-primary text-white"
                                       v-for="(header, index) in headers"
                                       :key="index">
                                    <div class="w-full" v-if="index != 0">
                                        <span>{{ header.title }}</span>
                                        <br/>
                                        <span>{{ header.date }}</span>
                                    </div>
                                </vs-th>
                            </template>
                            <template slot-scope="{data}" style="height: 0">
                                <vs-tr :key="index" v-for="(item, index) in data" :state="'success'">
                                    <vs-td class="cursor-pointer border bg-primary text-white"
                                           style="min-width:150px !important;font-size:14px; position: sticky; left: 0; z-index: 2">
                                        {{ item.fullName }}
                                    </vs-td>
                                    <vs-td class="cursor-pointer border text-center p-0"
                                           :style="data.date.getTime() < dateNowFormat.getTime() ? `background-color: #c7c7c7` : data.date.getTime() == dateNowFormat.getTime() ? `background-color: #D4F0FC` : null"
                                           v-for="(data, indexDate) in (arrayDate.length > 7 ? arrayDate.slice(0, 7) : arrayDate)"
                                           :key="indexDate">
                                        <div class="w-full h-full" @mouseover="updateDayOfWeeks(item, indexDate, index)"
                                             @mouseout="updateDayOfWeeks(item, indexDate, index)">
                                            <div class="w-full h-full grid justify-center"
                                                 v-if="item.workshifts && item.workshifts.filter(el => el.strWorkStartAt === data.dateFormat).length > 0">
                                                <div class="p-2"
                                                     style="display:grid; max-width: 300px; min-width: 178px"
                                                     @click="editSchedule(workshift, data.date, item, data.date)"
                                                     v-for="(workshift, indexWorkshift) in item.workshifts.filter(el => el.strWorkStartAt === data.dateFormat && !el.studentId)"
                                                     :key="indexWorkshift"
                                                     @mouseover="mouseoverCard($event, data, workshift)"
                                                     @mouseout="mouseoutCard">
                                                    <span class="p-2 border-radius"
                                                          :style="(data.date.getTime() < dateNowFormat.getTime() || workshift.status === 1) ? `background-color: #aaa; color: #8F8D7D` : `background-color:${workshift.color}; color: #fff`">
                                                        <span class="vx-card"
                                                              :style="(data.date.getTime() >= dateNowFormat.getTime() && workshift.teacherType != 1 && workshift.status === 0) ? `background-color: rgba(var(--vs-primary),1); color: #fff` : `color: #8F8D7D`">{{
                                                                workshift.teacherTypeName
                                                            }}</span>
                                                        <span>{{ workshift.organizationBranchName }}</span>
                                                        <br>
                                                        {{ workshift.className }}
                                                        <br>
                                                        <!--                                                        <span>{{ workshift.name }} ({{ workshift.startTimeFormat }} - {{-->
                                                        <!--                                                                workshift.endTimeFormat-->
                                                        <!--                                                            }})</span>-->
                                                        <!--                                                        <br>-->
                                                        <!--                                                        <span>Điểm danh: </span>-->
                                                        <!--                                                        <span>{{ workshift.countCheckinStudent }}/</span>-->
                                                        <!--                                                        <span>{{ workshift.totalStudent }}</span>-->
                                                        <!--                                                        <div class="flex justify-center	">-->
                                                        <!--                                                            <vs-dropdown>-->
                                                        <!--                                                                <vs-avatar :src="workshift.urlImage"/>-->
                                                        <!--                                                                <vs-dropdown-menu>-->
                                                        <!--                                                                    <div class="p-4 text-center sizeDropdown">-->
                                                        <!--                                                                        <div>-->
                                                        <!--                                                                            <vs-avatar-->
                                                        <!--                                                                                style="border: 2px solid rgba(var(&#45;&#45;vs-primary),1)"-->
                                                        <!--                                                                                :src="workshift.urlImage" size="large"/>-->
                                                        <!--                                                                        </div>-->
                                                        <!--                                                                        <div>-->
                                                        <!--                                                                            <div class="font-bold">{{-->
                                                        <!--                                                                                    workshift.fullNameMain ? workshift.fullNameMain : item.fullName-->
                                                        <!--                                                                                }}</div>-->
                                                        <!--                                                                            <div class="text-primary">{{-->
                                                        <!--                                                                                    $t('workShiftByDay.teachingMain')-->
                                                        <!--                                                                                }}</div>-->
                                                        <!--                                                                        </div>-->
                                                        <!--                                                                    </div>-->
                                                        <!--                                                                </vs-dropdown-menu>-->
                                                        <!--                                                            </vs-dropdown>-->
                                                        <!--                                                            <div v-for="(i, ind) in workshift.employeeExtraData"-->
                                                        <!--                                                                 :key="ind" v-if="workshift.teacherType != 1">-->
                                                        <!--                                                                <vs-dropdown>-->
                                                        <!--                                                                    <vs-avatar :src="i.url"/>-->
                                                        <!--                                                                    <vs-dropdown-menu>-->
                                                        <!--                                                                        <div class="p-4 text-center sizeDropdown">-->
                                                        <!--                                                                            <div>-->
                                                        <!--                                                                                <vs-avatar-->
                                                        <!--                                                                                    style="border: 2px solid rgba(var(&#45;&#45;vs-warning),1)"-->
                                                        <!--                                                                                    :src="i.url" size="large"/>-->
                                                        <!--                                                                            </div>-->
                                                        <!--                                                                            <div>-->
                                                        <!--                                                                                <div class="font-bold">{{-->
                                                        <!--                                                                                        i.fullName-->
                                                        <!--                                                                                    }}</div>-->
                                                        <!--                                                                                <div class="text-warning">{{-->
                                                        <!--                                                                                        $t('workShiftByDay.teachingAssistant')-->
                                                        <!--                                                                                    }}</div>-->
                                                        <!--                                                                            </div>-->
                                                        <!--                                                                        </div>-->
                                                        <!--                                                                    </vs-dropdown-menu>-->
                                                        <!--                                                                </vs-dropdown>-->
                                                        <!--                                                            </div>-->
                                                        <!--                                                        </div>-->
                                                    </span>
                                                </div>
                                                <div class="w-full">
                                                    <div class="w-full p-2 m-auto" style="display:grid">
                                                        <vx-tooltip color="primary" class="mt-1" text="Thêm ca"
                                                                    position="top">
                                                            <vs-button v-show="item.dayOfWeeks[indexDate]"
                                                                       class="w-full"
                                                                       icon-pack="feather" icon="icon-plus"
                                                                       v-if="data.date.getTime() >= dateNowFormat.getTime() && isPermissionAdd()"
                                                                       @click="addSchedule(item, data.date, data.date)"></vs-button>
                                                        </vx-tooltip>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="w-full h-full vx-col"
                                                 v-if="item.workshifts.filter(el => el.strWorkStartAt === data.dateFormat).length === 0 && data.date.getTime() >= dateNowFormat.getTime() && isPermissionAdd()"
                                            >
                                                <div class="w-full p-2 m-auto" style="height:5rem">
                                                    <vx-tooltip color="primary" class="mt-1" text="Thêm ca"
                                                                position="top">
                                                        <vs-button v-show="item.dayOfWeeks[indexDate]"
                                                                   class="w-full mt-2"
                                                                   icon-pack="feather" icon="icon-plus"
                                                                   @click="addSchedule(item, data.date, data.date)"></vs-button>
                                                    </vx-tooltip>
                                                </div>
                                            </div>
                                        </div>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </div>
            </div>
        </div>
        <vs-popup :title="isUpdate ? 'Cập nhật lịch học' : 'Tạo mới lịch học'" :active.sync="activePopup">
            <div class="vx-row">
                <!-- <div class="vx-col w-full mt-4">
                    <small class="date-label">Tên nhóm làm việc <span class="text-danger">*</span></small>
                    <vs-input v-validate="'required'" name="groupName" class="w-full" v-model="workshiftByDay.groupName"></vs-input>
                    <span class="text-danger text-sm">{{ errors.first('groupName') }}</span>
                </div> -->
                <div class="vx-col w-full mt-4">
                    <small class="date-label">{{ $t('navMenu.school') }}<span class="text-danger">*</span></small>
                    <v-select v-validate="'required'" name="organizationBranchName" class="w-full"
                              v-model="organizationBranchModel" :options="branchList" :clearable="false">
                        <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('organizationBranchName') }}</span>
                </div>
                <div class="vx-col w-full mt-4">
                    <small class="date-label">{{$t('classRoom.classRoom') }} <span class="text-danger">*</span></small>
                    <v-select v-validate="'required'" name="classRoom" class="w-full" :clearable="false"
                              v-model="classRoomModel" :options="classRoomOptions" :disabled="isExtra">
                        <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('classRoom') }}</span>
                </div>
                <div class="vx-col w-full mt-4">
                    <small class="date-label">{{$t('dashboard.teachingShift') }} <span class="text-danger">*</span></small>
                    <v-select v-validate="'required'" name="workshift" class="w-full"
                              v-model="teachingScheduleModel" :options="teachingScheduleOptions"
                              :disabled="isExtra" :clearable="false">
                        <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('workshift') }}</span>
                </div>
                <div class="vx-col w-full mt-4">
                    <small class="date-label">{{$t('workShiftByDay.nameShift') }}</small>
                    <vs-input :disabled="true" class="w-full" v-model="workshiftByDay.workShiftName"></vs-input>
                </div>
                <div class="vx-col w-full mt-4">
                    <small class="date-label">{{ $t('workShiftByDay.teachingMain') }}<span
                        class="text-danger">*</span></small>
                    <v-select v-validate="'required'" name="employee" class="w-full" v-model="employeeModel"
                              :options="allEmployeeOptions" disabled>
                        <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('employee') }}</span>
                </div>
                <div class="vx-col w-full mt-4">
                    <small class="date-label">{{ $t('workShiftByDay.teachingAssistant') }}</small>
                    <v-select class="w-full" v-model="employeeExtra" multiple
                              :options="employeeExtraOptions" :disabled="isExtra">
                        <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>
                    </v-select>
                </div>
                <div class="vx-col w-full mt-4">
                    <small class="date-label">{{ this.$t('workShiftByDay.workDay') }}</small>
                    <datepicker v-validate="'required'" :format="'dd/MM/yyyy'" name="startDate"
                                v-model="workshiftByDay.startDate" :disabled="true"
                                style="width: 100%;"></datepicker>
                    <span class="text-danger text-sm">{{ errors.first('startDate') }}</span>
                </div>
                <div class="vx-col w-full mt-4" v-if="isUpdate">
                    <vs-checkbox v-model="checkBoxRest">{{ $t('employeeStatus.rest') }}</vs-checkbox>
                </div>
                <div class="vx-col w-full mt-4">
                    <small class="date-label">{{ $t('invoice.note') }}</small>
                    <vs-textarea v-model="workshiftByDay.note" name="note"
                                 placeholder="VD: Phòng A tầng 3 ..."/>
                    <!-- <span class="text-danger text-sm">{{ errors.first('description') }}</span> -->
                </div>
                <div class="vx-col w-full mt-2" v-show="workshiftByDay.startTime && workshiftByDay.endTime">
                    <div class="w-full p-4 mt-4" style="border:1px solid #ccc;border-radius:5px">
                        <div class="vx-row">
                            <div class="vx-col w-full">
                                <div class="w-full">
                                    <small class="date-label">{{ $t('workShift.startTime') }}</small>
                                    <vs-input :disabled="true" class="w-full" type="time"
                                              v-model="workshiftByDay.startTime"></vs-input>
                                </div>
                                <div class="w-full mt-1">
                                    <small class="date-label">{{ $t('workShift.endTime') }}</small>
                                    <vs-input :disabled="true" class="w-full" type="time"
                                              v-model="workshiftByDay.endTime"></vs-input>
                                </div>
                            </div>
                            <!-- <div class="vx-col md:w-2/12 w-full mt-8">
                                <vs-button class="bg-danger" icon-pack="feather" icon="icon-trash" @click="removeRecord(indexWork)"></vs-button>
                                <vs-button class="mt-4" icon-pack="feather" icon="icon-plus" @click.prevent="addRecord"></vs-button>
                            </div> -->
                        </div>
                    </div>
                </div>

                <!-- <div class="vx-col w-full">
                    <label class="vs-input--label"></label>
                    <vs-checkbox v-model="workshiftByDay.advanceSetting">
                        {{this.$t('workShiftByDay.settingAdvance')}}
                    </vs-checkbox>
                </div> -->
            </div>
            <div class="vx-row" v-if="false">
                <div class="vx-col w-full mt-4">
                    <vs-input :disabled="disabledFrom" class="w-full" :label="this.$t('workShiftByDay.flexible')"
                              v-model="workshiftByDay.bufferTime" name="bufferTime"
                              v-validate="'required|numeric'"/>
                    <span class="text-danger text-sm">{{ errors.first('bufferTime') }}</span>
                </div>

                <div class="vx-col w-full mt-4">
                    <small class="date-label">{{ this.$t('workShiftByDay.allowAdvance') }} <span
                        class="text-danger">*</span></small>
                    <vs-input class="w-full" type="time" :disabled="disabledFrom"
                              :value="workshiftByDay.allowCheckInBefore"/>
                </div>

                <div class="vx-col w-full mt-4">
                    <small class="date-label">{{ this.$t('workShiftByDay.allowInlater') }} <span
                        class="text-danger">*</span></small>
                    <vs-input class="w-full" type="time" :disabled="disabledFrom"
                              :value="workshiftByDay.allowCheckInAfter"/>
                </div>

                <div class="vx-col w-full mt-4">
                    <small class="date-label">{{ this.$t('workShiftByDay.allowCheckOutIn') }} <span
                        class="text-danger">*</span></small>
                    <vs-input class="w-full" type="time" :disabled="disabledFrom"
                              :value="workshiftByDay.allowCheckOutBefore"/>
                </div>

                <div class="vx-col w-full mt-4">
                    <small class="date-label">{{ this.$t('workShiftByDay.allowCheckOutLater') }} <span
                        class="text-danger">*</span></small>
                    <vs-input class="w-full" type="time" :disabled="disabledFrom"
                              :value="workshiftByDay.allowCheckOutAfter"/>
                </div>
            </div>
            <div class="vx-row mt-4">
                <div class="vx-col w-full flex">
                    <vs-button class="ml-auto" @click="saveChanges"
                               v-if="checkDate && (checkDate.getTime() >= dateNowFormat.getTime()) && isPermissionUpdate() && !isExtra && workshiftByDay.status !== 1"
                               :disabled="!validateForm || workshiftByDay.currentDateFormat < dateNowFormat">{{isUpdate ? $t('button.update') :  $t('button.create') }}
                    </vs-button>
                    <vs-button
                        v-if="isUpdate && isPermissionDelete() && checkDate && (checkDate.getTime() >= dateNowFormat.getTime()) && !isExtra && workshiftByDay.status !== 1"
                        :class="checkDate >= dateNowFormat ? 'ml-4 bg-danger' : 'ml-auto bg-danger'"
                        @click="removeWorkShift">{{ this.$t('button.delete') }}
                    </vs-button>
                    <vs-button v-else class="ml-auto" @click="activePopup = false" type="border" color="warning">Đóng
                    </vs-button>
                </div>
            </div>
        </vs-popup>
        <vs-popup class="holamundo" title="Thêm giáo viên vào TKB" :active.sync="popupAddTeacher"
                  id="popup-add-teacher">
            <div class="vx-row">
                <div class="vx-col w-1/2">
                    <div class="text-center font-semibold text-xl">
                        <span>{{ this.$t('statusActive.agree') }}</span>
                    </div>
                    <div class="mt-4" style="height: 37.59px"></div>
                    <div class="table_select">
                        <VuePerfectScrollbar ref="mainSidebarPs"
                                             class="scroll-area--list-employee"
                                             :settings="settings" :key="$vs.rtl">
                            <draggable v-model="employeeList"
                                       :options="dragOptions"
                                       group="people">
                                <div v-for="item in employeeList" :key="item.id"
                                     class="cursor-pointer item_select">
                                    <vs-list-item class="text-md font-semibold">{{
                                            item.fullName
                                        }}
                                    </vs-list-item>
                                </div>
                            </draggable>
                        </VuePerfectScrollbar>
                    </div>

                </div>
                <div class="vx-col w-1/2">
                    <div class="text-center font-semibold text-xl">
                        <span>{{ this.$t('employeeTypeOptions.teachersAvailable') }}</span>
                    </div>
                    <div class="mt-4">
                        <vs-input class="w-full" v-model="keySearchEmployeeAdd" placeholder="Tìm theo tên ..."
                                  @input="searchEmployeeAdd"></vs-input>
                    </div>
                    <div class="table_select">
                        <VuePerfectScrollbar ref="mainSidebarPs"
                                             class="scroll-area--list-employee"
                                             :settings="settings" :key="$vs.rtl">
                            <draggable v-model="employeeAddOptionsSearch"
                                       :options="dragOptions"
                                       :group="{name: 'people', put: false}">
                                <div v-for="item in employeeAddOptionsSearch" :key="item.id"
                                     class="cursor-pointer item_select">
                                    <vs-list-item class="text-md font-semibold">{{
                                            item.fullName
                                        }}
                                    </vs-list-item>
                                </div>
                            </draggable>
                        </VuePerfectScrollbar>
                    </div>
                </div>
            </div>
        </vs-popup>

        <div class="absolute select-none overflow-hidden shadow-lg p-2 text-center work-shift-hover"
             style="z-index: 55000;" v-if="isHover && workshiftSelect"
             :style="(workshiftSelect.data.date.getTime() < dateNowFormat.getTime() || workshiftSelect.workshift.status === 1) ? `background-color: #aaa; color: #8F8D7D; top: ${screenY}px; left: ${screenX}px` : `background-color:${workshiftSelect.workshift.color}; color: #fff; top: ${screenY}px; left: ${screenX}px`">
            <span>
                    <span class="vx-card"
                          :style="(workshiftSelect.data.date.getTime() >= dateNowFormat.getTime() && workshiftSelect.workshift.teacherType != 1 && workshiftSelect.workshift.status === 0) ? `background-color: rgba(var(--vs-primary),1); color: #fff` : `color: #8F8D7D`">{{
                            workshiftSelect.workshift.teacherTypeName
                        }}</span>
                    <span>{{ workshiftSelect.workshift.organizationBranchName }}</span>
                    <br>
                    {{ workshiftSelect.workshift.className }}
                    <br>
                    <span>{{
                            workshiftSelect.workshift.name
                        }} ({{ workshiftSelect.workshift.startTimeFormat }} - {{
                            workshiftSelect.workshift.endTimeFormat
                        }})</span>
                    <br>
                    <span>{{ this.$t('dashboard.attendance') }}: {{
                            workshiftSelect.workshift.countCheckinStudent
                        }}/{{ workshiftSelect.workshift.totalStudent }}</span>
                <br v-if="workshiftSelect.workshift.note">
                <span v-if="workshiftSelect.workshift.note">{{ this.$t('invoice.note') }}: {{ workshiftSelect.workshift.note }}</span>
                </span>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import {isAPI} from '../../../store/permission'
import {constAPI} from '../../../store/constant'
import draggable from 'vuedraggable'
import authConfig from '../../../../auth_config.json'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    computed: {
        classRoomModel: {
            get() {
                let object = this.classRoomOptions.find(el => el.value == this.workshiftByDay.classRoomId);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(object) {
                this.workshiftByDay.classRoomId = object ? object.value : null
            }
        },
        validateForm() {
            return !this.errors.any()
        },
        employeeModel: {
            get() {
                let object = this.allEmployeeOptions.find(el => el.value == this.workshiftByDay.employeeId);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(object) {
                this.workshiftByDay.employeeId = object ? object.value : null
            }
        },
        organizationBranchModel: {
            get() {
                let object = this.branchList.find(el => el.value === this.workshiftByDay.organizationBranchId);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            async set(object) {
                this.workshiftByDay.organizationBranchId = object ? object.value : null;
                if (this.workshiftByDay.organizationBranchId) {
                    this.classRoomOptions = [];
                    await this.getClassRoom();
                    await this.getTeachingSchedule();
                }
            }
        },
        teachingScheduleModel: {
            get() {
                let object = this.teachingScheduleOptions.find(el => el.value == this.workshiftByDay.teachingScheduleId);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value,
                    startTime: object.startTime,
                    endTime: object.endTime,
                    color: object.colorCode

                }
            },
            set(object) {
                this.workshiftByDay.teachingScheduleId = object ? object.value : null;
                this.workshiftByDay.startTime = object ? object.startTime : null;
                this.workshiftByDay.endTime = object ? object.endTime : null;
                this.workshiftByDay.color = object ? object.color : null;
                this.workshiftByDay.workShiftName = object ? object.label : null;
            }
        },

        selectedBranch: {
            get() {
                let object = this.branchOptions.find(el => el.value === this.selectedOrganizationBranchId)
                if (!object) return
                return {
                    label: object.label,
                    value: object.value,
                    employee: object.employee,
                }
            },
            set(obj) {
                this.selectedOrganizationBranchId = obj ? obj.value : null
                this.getSchedule()
            }
        }
    },
    components: {
        vSelect,
        Datepicker,
        draggable,
        VuePerfectScrollbar
    },
    data() {
        return {
            badge2: 0,
            classRoomOptions: [],
            classRoomList: [],
            dateNowFormat: null,
            showAddSchedule: false,
            teachingScheduleOptions: [],
            disabledFrom: false,
            arrayTimeWorkshift: [{}],
            workshiftByDay: {
                organizationBranchId: null,
                employeeId: null,
                startDate: null,
                startTime: null,
                endTime: null,
                color: null,
                advanceSetting: false,
                bufferTime: 0,
                allowCheckInBefore: 60,
                allowCheckInAfter: 60,
                allowCheckOutBefore: 60,
                allowCheckOutAfter: 60,
                classRoomId: null,
                status: 0
            },
            checkDate: null,
            datePicker: null,
            activePopup: false,
            isUpdate: false,
            arrayDate: [],
            weekOfYear: 0,
            date: {
                startDate: null,
                endDate: null,
                startDateFormat: null,
                endDateFormat: null
            },
            employeeList: [],
            // employeeOptions: [],
            employeeExtraOptions: [],
            branchList: [],
            // payload: {
            //     organizationBranchId: null,
            //     enabled: true,
            //     fromDate: null,
            //     toDate: null
            // },
            schedule: {},
            headers: [
                {title: '', date: null}, {title: 'Thứ 2', date: null}, {title: 'Thứ 3', date: null},
                {title: 'Thứ 4', date: null}, {title: 'Thứ 5', date: null}, {title: 'Thứ 6', date: null},
                {title: 'Thứ 7', date: null}, {title: 'Chủ nhật', date: null}
            ],
            employeeExtra: null,
            isExtra: false,
            branchOptions: [],
            selectedOrganizationBranchId: null,
            employeeSelectOptions: [],
            employeeAddOptions: [],
            employeeAddOptionsSearch: [],
            popupAddTeacher: false,
            dragOptions: {
                animation: 200,
            },
            selectedEmployee: 'null',
            workshiftSelect: null,
            screenX: null,
            screenY: null,
            isHover: false,
            checkBoxRest: false,
            allEmployeeOptions: [],
            keySearchEmployeeList: '',
            keySearchEmployeeAdd: '',
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            isMonitor: false,
        }
    },

    methods: {
        isPermissionAdd() {
            return isAPI(this, constAPI.schedule_add)
        },
        isPermissionUpdate() {
            return isAPI(this, constAPI.schedule_update)
        },
        isPermissionDelete() {
            return isAPI(this, constAPI.schedule_delete)
        },
        updateData() {
            let start = new Date(this.date.startDate.setHours(0, 0, 0));
            let end = new Date(this.date.endDate.setHours(23, 59, 59));
            let payload = {
                fromDate: start,
                toDate: end,
                type: 1,
            }
            this.$vs.loading();
            this.$crm.post('/employee/update-data', payload).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Cập nhật dữ liệu thành công',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success'
                })
                this.getSchedule();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        getClassRoom() {
            return new Promise((resolve, reject) => {
                let userInfo = JSON.parse(localStorage.getItem('userInfo'))
                let payload = {
                    status: true,
                    organizationId: userInfo.organization.id
                }
                this.$vs.loading();
                this.$crm.post(`/school-classroom/get-all-class`, payload).then((res) => {
                    this.classRoomList = res.data;
                    this.classRoomOptions = res.data.filter(el => el.organizationBranchId == this.workshiftByDay.organizationBranchId && el.status).map(el => {
                        return {
                            label: el.className,
                            value: el.id,
                            organizationBranchId: el.organizationBranchId
                        }
                    });
                    resolve(res);
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
        updateDayOfWeeks(data, index, indexEmployee) {
            data.dayOfWeeks[index] = !data.dayOfWeeks[index];
            this.employeeList.splice(indexEmployee, data);
        },
        removeWorkShift() {
            this.activePopup = false;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá "${this.workshiftByDay.workShiftName}" không ?`,
                accept: this.deleteRecord,
                cancel: this.cancelRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        cancelRecord() {
            this.activePopup = true;
        },
        deleteRecord() {
            this.$vs.loading();
            this.$crm.post(`employee-workshift-by-day/delete/${this.workshiftByDay.id}`).then(() => {
                this.$vs.loading.close();
                this.activePopup = false;
                this.getSchedule();
                return this.$vs.notify({
                    text: 'Xoá thành công lịch dạy',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success'
                });
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        getTeachingSchedule() {
            return new Promise((resolve, reject) => {
                const payload = {
                    type: 1,
                    organizationBranchId: this.workshiftByDay.organizationBranchId
                }
                this.$vs.loading();
                this.$crm.post('/teaching-schedule/find-all', payload).then((res) => {
                    this.$vs.loading.close();
                    this.teachingScheduleOptions = res.data.map(el => {
                        return {
                            label: el.name,
                            value: el.id,
                            startTime: el.startTime,
                            endTime: el.endTime,
                            color: el.colorCode
                        }
                    });
                    resolve(res)
                }).catch((err) => {
                    this.$vs.loading.close();
                    reject(err)
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
        convertHoustToMinutes(data) {
            let strArray = data.split(':');
            return parseInt(strArray[0]) * 60 + parseInt(strArray[1])
        },
        async saveChanges() {
            // this.arrayTimeWorkshift.forEach(el => {
            //     let object = {};
            //     object['startTime'] = this.convertHoustToMinutes(el.startTime);
            //     object['endTime'] = this.convertHoustToMinutes(el.endTime);
            //     if (object.advanceSetting) {
            //         object.allowCheckInAfter = this.convertHoustToMinutes(object.allowCheckInAfter);
            //         object.allowCheckInBefore = this.convertHoustToMinutes(object.allowCheckInBefore);
            //         object.allowCheckOutAfter = this.convertHoustToMinutes(object.allowCheckOutAfter);
            //         object.allowCheckOutBefore = this.convertHoustToMinutes(object.allowCheckOutBefore);
            //     }
            //     if (this.payload.organizationBranchId) data.organizationBranchId = this.payload.organizationBranchId;
            //     payload.push({...object, ...data});
            // })
            const result = await this.$validator.validateAll();
            if (!result) return;
            // if (isNaN(this.workshiftByDay.allowCheckInAfter)) this.workshiftByDay.allowCheckInAfter = this.convertHoustToMinutes(this.workshiftByDay.allowCheckInAfter);
            // if (isNaN(this.workshiftByDay.allowCheckInBefore)) this.workshiftByDay.allowCheckInBefore = this.convertHoustToMinutes(this.workshiftByDay.allowCheckInBefore);
            // if (isNaN(this.workshiftByDay.allowCheckOutAfter)) this.workshiftByDay.allowCheckOutAfter = this.convertHoustToMinutes(this.workshiftByDay.allowCheckOutAfter);
            // if (isNaN(this.workshiftByDay.allowCheckOutBefore)) this.workshiftByDay.allowCheckOutBefore = this.convertHoustToMinutes(this.workshiftByDay.allowCheckOutBefore);
            this.workshiftByDay.groupName = this.workshiftByDay.workShiftName

            if ((this.checkDate < this.dateNowFormat)) {
                return this.$vs.notify({
                    text: 'Ca làm việc đã qua thời gian kết thúc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if (this.employeeExtra) {
                this.workshiftByDay.teacherExtra = this.employeeExtra.map(x => {
                    return x['value']
                })
            }

            this.workshiftByDay.status = this.checkBoxRest ? 1 : 0

            let payload = {...this.workshiftByDay};
            if (isNaN(payload.startTime)) payload.startTime = this.convertHoustToMinutes(this.workshiftByDay.startTime);
            if (isNaN(payload.endTime)) payload.endTime = this.convertHoustToMinutes(this.workshiftByDay.endTime);
            if (this.isUpdate) {
                payload = {
                    ...payload,
                    allowCheckInBefore: 5,
                    allowCheckInAfter: 20,
                    allowCheckOutBefore: 0,
                    allowCheckOutAfter: 0,
                }
            }
            let url = this.isUpdate ? 'employee-workshift-by-day/update' : 'employee-workshift-by-day/create'
            payload.advanceSetting = true;
            this.$vs.loading();
            this.$crm.post(url, payload).then(() => {
                this.activePopup = false;
                this.getSchedule();
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: `${this.isUpdate ? 'Cập nhật' : 'Tạo mới'} thời khoá biểu thành công!`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success'
                })
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        removeRecord(index) {
            this.arrayTimeWorkshift.splice(index, 1);
        },
        addRecord() {
            this.arrayTimeWorkshift.push({});
        },
        async addSchedule(data, date, dateFormat) {
            this.employeeExtra = null
            this.isExtra = false
            this.checkDate = dateFormat
            this.isUpdate = false;
            this.workshiftByDay = {
                teachingScheduleId: null,
                color: null,
                startDate: null,
                startTime: null,
                endTime: null,
                advanceSetting: false,
                bufferTime: 0,
                allowCheckInBefore: 60,
                allowCheckInAfter: 60,
                allowCheckOutBefore: 60,
                allowCheckOutAfter: 60,
                organizationBranchId: this.selectedOrganizationBranchId,
                employeeId: data.employeeId,
                currentDateFormat: moment(date).format("DD/MM"),
                departmentType: data.departmentType,
                classRoomId: null
            };
            if (this.workshiftByDay.organizationBranchId) {
                this.classRoomOptions = [];
                await this.getClassRoom();
                await this.getTeachingSchedule();
            }
            // this.getClassRoom()
            // this.getTeachingSchedule()
            this.employeeExtraOptions = this.allEmployeeOptions.filter(x => x.value != data.employeeId)
            this.arrayTimeWorkshift = [{}];
            this.workshiftByDay.startDate = null;
            this.workshiftByDay.workDate = null;
            this.activePopup = true;
            this.workshiftByDay.startDate = date;
            this.workshiftByDay.workDate = date;
            this.$validator.reset();
        },
        formatMinuteToHours(data) {
            let hours = Math.floor(data / 60)
            let minutes = data % 60 == 0 ? '00' : data % 60;
            let result = (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 && minutes > 0 ? '0' + minutes : minutes);
            return result;
        },
        async editSchedule(data, date, dataEmployee, dateFormat) {
            this.isExtra = data.teacherType == 1 ? true : false
            this.checkDate = dateFormat
            this.arrayTimeWorkshift = [];
            this.workshiftByDay = {};
            this.workshiftByDay.startDate = null;
            this.activePopup = true;
            this.workshiftByDay = {
                teachingScheduleId: data.teachingScheduleId,
                workShiftName: data.workShiftName,
                id: data.id,
                groupName: data.groupName,
                color: data.color,
                startDate: data.startDate,
                startTime: data.startTimeFormat,
                endTime: data.endTimeFormat,
                advanceSetting: data.advanceSetting,
                bufferTime: data.bufferTime,
                allowCheckInBefore: data.allowCheckInBefore,
                allowCheckInAfter: data.allowCheckOutBefore,
                allowCheckOutBefore: data.allowCheckOutBefore,
                allowCheckOutAfter: data.allowCheckOutAfter,
                organizationBranchId: data.organizationBranchId,
                employeeId: this.isExtra ? data.teacherMainId : data.employeeId,
                departmentType: dataEmployee.departmentType,
                classRoomId: data.classRoomId,
                note: data.note,
                status: data.status,
            };
            this.checkBoxRest = !!data.status
            await this.getClassRoom()
            await this.getTeachingSchedule();

            if (data.teacherExtra.length > 0) {
                let result = data.teacherExtra.map(x => {
                    let obj = {}
                    obj['value'] = x
                    return obj
                })
                this.employeeExtra = result.map(el => {
                    let extra = this.allEmployeeOptions.find(x => x.value == el.value)
                    if (extra) el.label = extra.label
                    return el
                })
            } else {
                this.employeeExtra = null
            }

            // this.workshiftByDay = data;
            this.employeeExtraOptions = this.allEmployeeOptions.filter(x => x.value != data.employeeId)
            this.workshiftByDay.startDate = date;
            this.workshiftByDay.workDate = date;
            this.isUpdate = true;

            //data teaching schedule
            let object = this.teachingScheduleOptions.find(el => el.value === data.teachingScheduleId);
            if (object) {
                this.workshiftByDay.teachingScheduleId = object.value;
                this.workshiftByDay.workShiftName = object.label;
                this.workshiftByDay.startTime = object.startTime;
                this.workshiftByDay.endTime = object.endTime;
            }

        },
        getNextWeek() {
            let today = moment();
            let daysToMonday = 0 - (today.isoWeekday() - 1) + 7;
            let nextMonday = today.subtract('days', daysToMonday);
            return nextMonday;
        },
        getLastWeek() {
            let today = moment();
            let daysToLastMonday = 0 - (1 - today.isoWeekday()) + 7;
            let lastMonday = today.subtract('days', daysToLastMonday);
            return lastMonday;
        },
        previousDate() {
            let prevStart = moment(this.date.startDate).weekday(-6);
            let prevEnd = moment(this.date.startDate).weekday(0);
            this.date.startDate = new Date(prevStart);
            this.date.endDate = new Date(prevEnd);
            this.date.startDateFormat = prevStart.format('DD/MM/YYYY');
            this.date.endDateFormat = prevEnd.format('DD/MM/YYYY');
            this.loopDateRange(false);
            this.getSchedule();
        },
        nextDate() {
            let nextStart = moment(this.date.startDate).weekday(8);
            let nextEnd = moment(this.date.startDate).weekday(14);
            this.date.startDate = new Date(nextStart);
            this.date.endDate = new Date(nextEnd);
            this.date.startDateFormat = nextStart.format('DD/MM/YYYY');
            this.date.endDateFormat = nextEnd.format('DD/MM/YYYY');
            this.loopDateRange(false);
            this.getSchedule();
        },
        getWeekNumber(d) {
            // Copy date so don't modify original
            d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
            // Set to nearest Thursday: current date + 4 - current day number
            // Make Sunday's day number 7
            d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
            // Get first day of year
            let yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
            // Calculate full weeks to nearest Thursday
            let weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
            // Return array of year and week number
            return weekNo;
        },
        getSchedule() {
            this.employeeList = []
            let start = new Date(this.date.startDate.setHours(0, 0, 0, 0));
            let end = new Date(this.date.endDate.setHours(23, 59, 59, 999));
            let payload = {
                fromDate: start,
                toDate: end,
                type: 1
            }
            if (this.isMonitor) payload['monitor'] = true
            if (this.selectedOrganizationBranchId) payload['organizationBranchId'] = this.selectedOrganizationBranchId
            if (JSON.parse(this.selectedEmployee)) payload['employeeId'] = JSON.parse(this.selectedEmployee)
            this.$vs.loading();
            this.$crm.post('/employee/find-all-schedule', payload).then((res) => {
                if (res.data && res.data.length > 0) {
                    let employeeData = res.data
                    let schedule = res.data.map(el => {
                        let arrWorkshift = [];
                        el.employeeWorkShiftByDays = el.employeeWorkShiftByDays.filter(workshift => workshift.classRoomId && !!(this.branchOptions.find(t => t.value === workshift.organizationBranchId))).map(x => {
                            let branch = this.branchList.find(el => el.value === x.organizationBranchId);
                            if (branch) x.organizationBranchName = branch.label;
                            let classRoom = this.classRoomList.find(room => room.id === x.classRoomId);
                            if (classRoom) x.className = classRoom.className;
                            x.startTimeFormat = this.formatMinuteToHours(x.startTime)
                            x.endTimeFormat = this.formatMinuteToHours(x.endTime)
                            x.strWorkEndAt = moment(new Date(x.workEndAt)).format("DD/MM");
                            x.strWorkStartAt = moment(new Date(x.workStartAt)).format("DD/MM");
                            x.teacherTypeName = x.teacherType == 1 ? this.$t('workShiftByDay.teachingAssistant') : this.$t('workShiftByDay.teachingMain');

                            if (x.teacherType != 1) {
                                x.urlImage = el.fileManagers.length > 0 ? el.fileManagers[0].url : null;
                            } else {
                                let result = employeeData.find(t => t.employeeId == x.teacherMainId)
                                if (result) {
                                    x.urlImage = result.fileManagers.length > 0 ? result.fileManagers[0].url : null
                                    x.fullNameMain = result.fullName
                                }
                            }
                            if (x.teacherExtra) {
                                x.employeeExtraData = x.teacherExtra.map(t => {
                                    let obj = {}
                                    obj['employeeId'] = t
                                    let result = employeeData.find(x => x.employeeId == t)
                                    if (result) {
                                        obj['url'] = result.fileManagers.length > 0 ? result.fileManagers[0].url : null
                                        obj['fullName'] = result.fullName
                                    }
                                    return obj
                                })
                            }

                            //get name work shift
                            let name = this.teachingScheduleOptions.find(el => (el.value == x.teachingScheduleId));
                            if (name) {
                                x.name = name.label;
                                x.color = name.color;
                                x.startTimeFormat = name.startTime,
                                    x.endTimeFormat = name.endTime
                            }
                            this.arrayDate.forEach(date => {
                                if (date.dateFormat == x.strWorkStartAt) arrWorkshift.push(x);
                            })

                            return x;
                        })
                        el.workshifts = arrWorkshift;
                        el.dayOfWeeks = [false, false, false, false, false, false, false];
                        return el;
                    });

                    this.employeeList = schedule.filter(el => el.employeeWorkShiftByDays.length > 0)

                    if (!JSON.parse(this.selectedEmployee)) {
                        this.employeeSelectOptions = res.data.map(el => {
                            return {
                                value: el.id,
                                label: el.fullName,
                            }
                        });
                        this.employeeSelectOptions.unshift({value: 'null', label: 'Tất cả'})
                    }
                    this.employeeAddOptions = schedule.filter(el => el.employeeWorkShiftByDays.length === 0);
                    this.employeeAddOptionsSearch = this.employeeAddOptions
                }
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        async initScreen() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'))
            let permission = JSON.parse(localStorage.getItem('permissions'))
            let result = permission.find(el => el.functionName === 'PRIVILEGE_EMPLOYEE_SCHEDULE_ALL')
            if (result || userInfo.userRole === 'organization') {
                this.isMonitor = true
                let branchList = JSON.parse(localStorage.getItem('branchInfoList') || []);
                this.branchList = branchList.filter(x => x.organizationBranchType === 3).map(el => {
                    return {
                        label: el.organizationBranchName,
                        value: el.id
                    }
                });
                this.branchOptions = branchList;
                this.branchOptions = this.branchOptions.filter(x => x.organizationBranchType === 3).map(el => {
                    return {
                        label: el.organizationBranchName,
                        value: el.id,
                        employee: el.employee ? el.employee.fullName : null,
                    }
                });
                this.branchOptions.unshift({value: null, label: 'Tất cả'})
            }
            if (!result && userInfo.userRole !== 'organization') {
                await this.getBranchResponsible()
                let result1 = permission.find(el => el.functionName === 'PRIVILEGE_SCHOOL_SCHEDULE_ALL')
                let result2 = permission.find(el => el.functionName === 'PRIVILEGE_TEACHER')
                if (result1 && result2) this.isMonitor = true
            }
        },
        loopDateRange(isWeek) {
            this.arrayDate = [];
            let currentMoment = moment(this.date.startDate);
            let lastDay = isWeek ? moment(this.date.endDate) : moment(this.date.endDate).add(1, 'days');
            let index = 1;
            while (currentMoment.isBefore(lastDay)) {
                let date = new Date(currentMoment.format('MM/DD/YYYY'));
                let object = {
                    date: date,
                    dateFormat: currentMoment.format('DD/MM'),
                    workshifts: [],
                    showAddSchedule: false
                }
                this.arrayDate.push(object);
                if (this.headers[index]) {
                    this.headers[index].date = currentMoment.format('DD/MM');
                    index++;
                }
                currentMoment.add(1, 'days');
            }
            this.weekOfYear = this.getWeekNumber(this.date.startDate);
        },
        exportTeachingSchedule() {
            let start = new Date(this.date.startDate.setHours(0, 0, 0, 0));
            let end = new Date(this.date.endDate.setHours(23, 59, 59, 999));
            let payload = {}
            payload['fromDate'] = start;
            payload['toDate'] = end;
            payload['type'] = 1;
            if (this.selectedOrganizationBranchId) payload['organizationBranchId'] = this.selectedOrganizationBranchId
            if (JSON.parse(this.selectedEmployee)) payload['employeeId'] = JSON.parse(this.selectedEmployee)
            this.$vs.loading();

            this.$crm.post('/time-keeping/export-teaching-schedule', payload).then(res => {
                this.$vs.loading.close();
                window.open(authConfig.crmDomain + "file/" + res.data + "?access_token=" + localStorage.getItem("access_token"), "_blank");
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        mouseoverCard(e, data, workshift) {
            this.workshiftSelect = {
                data: data,
                workshift: workshift
            }
            let availWidth = screen.availWidth
            this.screenX = (e.pageX + 510) > availWidth ? (e.pageX - 570) : (e.pageX - 250)
            this.screenY = e.pageY - 70
            this.isHover = true
        },

        mouseoutCard() {
            this.workshiftSelect = null
            this.screenX = null
            this.screenY = null
            this.isHover = false
        },

        exportTeachingSchoolSchedule() {
            if (!this.selectedOrganizationBranchId) {
                return this.$vs.notify({
                    text: 'Hãy chọn trường trước khi xuất TKH theo trường!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            let start = new Date(this.date.startDate.setHours(0, 0, 0, 0));
            let end = new Date(this.date.endDate.setHours(23, 59, 59, 999));
            let payload = {}
            payload['fromDate'] = start;
            payload['toDate'] = end;
            payload['type'] = 1;
            payload['organizationBranchId'] = this.selectedOrganizationBranchId
            this.$vs.loading();

            this.$crm.post('/time-keeping/export-teaching-school-schedule', payload).then(res => {
                this.$vs.loading.close();
                window.open(authConfig.crmDomain + "file/" + res.data + "?access_token=" + localStorage.getItem("access_token"), "_blank");
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        getAllTeacher() {
            return new Promise((resolve, reject) => {
                let payload = {
                    departmentType: 1,
                    enabled: true,
                }

                this.$vs.loading()
                this.$crm.post('/employee/all', payload).then(res => {
                    this.$vs.loading.close();
                    this.allEmployeeOptions = res.data.map(el => {
                        return {
                            value: el.employeeId,
                            label: el.fullName,
                            organizationBranchId: el.organizationBranchId
                        }
                    })
                    resolve(res)
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        searchEmployeeAdd() {
            this.employeeAddOptionsSearch = this.employeeAddOptions.filter(el => el.fullName.toLowerCase().includes(this.keySearchEmployeeAdd))
        },

        getBranchResponsible() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()
                this.$crm.get('organization-branch/get-responsible-branch').then(res => {
                    this.$vs.loading.close();
                    if (res.data && res.data.length > 0) {
                        this.branchOptions = res.data.map(el => {
                            return {
                                label: el.organizationBranchName,
                                value: el.id,
                                employee: el.employee ? el.employee.fullName : null,
                            }
                        });
                        this.branchList = res.data.map(el => {
                            return {
                                label: el.organizationBranchName,
                                value: el.id
                            }
                        });
                    } else {
                        this.branchOptions = []
                    }
                    this.branchOptions.unshift({value: null, label: 'Tất cả'})
                    resolve(res)
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },
    },
    async created() {
        let first = moment(new Date()).weekday(1)
        let last = moment(new Date()).weekday(7)
        this.date.startDate = new Date(first)
        this.date.endDate = new Date(last)
        this.date.startDateFormat = moment(this.date.startDate).format("DD/MM/YYYY")
        this.date.endDateFormat = moment(this.date.endDate).format("DD/MM/YYYY")
        this.loopDateRange(false)
        await this.initScreen()
        await this.getClassRoom()
        await this.getTeachingSchedule()
        await this.getAllTeacher()
        this.getSchedule()
        let formatDate = moment(new Date(new Date().setHours(0, 0, 0, 0))).format('MM/DD/YYYY')
        this.dateNowFormat = new Date(formatDate)
    },
}
</script>

<style lang="scss">
.height-table thead th {
    position: sticky;
    top: 0;
    z-index: 1;
}

.height-table thead th:first-child {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 10;
}

.height-table .vs-con-table .vs-con-tbody {
    max-height: calc(var(--vh, 1vh) * 100 - 286px) !important;
    overflow: auto;
}

.border {
    border: 1px solid #ccc
}

.size-button {
    height: 25px !important;
    width: 25px !important;
}

.vs-component .vs-popup {
    //max-width: 450px !important;
}

.border-radius {
    border-radius: 5px;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
    background-color: transparent !important;
    transform: translateY(0px);
}

.con-vs-dropdown--menu .sizeDropdown {
    width: 200px;
}

#popup-add-teacher {
    .vs-popup {
        max-width: 1000px !important;
    }
}


.table_select {
    border: 1px dashed #dbdade;
    border-radius: 0.375rem;
    padding: 0.75rem;
    margin-top: 1.5rem;

    .scroll-area--list-employee {
        max-height: calc(var(--vh, 1vh) * 100 - 300px);
    }
}

.item_select {
    border: 1px solid #dbdade;
    border-radius: 0.375rem;
    margin-top: 0.3rem;
}

.vs-list--slot {
    margin-left: inherit !important;
}

.work-shift-hover {
    border-radius: 1rem;
    width: 300px;
}

</style>

